import { t } from '@lingui/core/macro';

type PageType =
  | 'analytics'
  | 'channel'
  | 'vendor'
  | 'campaign'
  | 'pixel'
  | 'audience'
  | 'companySettings'
  | 'vendorSpendSettings'
  | 'channelMappingSettings';

export const exampleAIQuestions = (pageType: PageType) => {
  switch (pageType) {
    case 'analytics':
      return [
        t`What's the most recent opportunity I won?`,
        t`What are the most recent companies that visited my site?`,
        t`Where is my bot traffic mostly coming from?`,
      ];
    case 'channel':
      return [
        t`What’s my best performing channel in terms of Pipeline Influence?`,
        t`Where do I go to see vendor data?`,
        t`Rank my channels using fit score`,
      ];
    case 'vendor':
      return [
        t`Rank my vendors using the fit score to my TAM`,
        t`Where can I see campaign performance?`,
        t`How do I add a vendor?`,
      ];
    case 'campaign':
      return [
        t`Rank my campaigns using the fit score to my TAM`,
        t`What's my worst campaign by fit score?`,
        t`How do I improve my campaigns with the lowest fit score?`,
      ];
    case 'pixel':
      return [
        t`Which of my pixels has the most impressions over its lifetime?`,
        t`What's my most efficient pixel?`,
        t`How do I deploy pixels with different vendors?`,
        t`What do I do if my efficiency is very low?`,
      ];
    case 'audience':
      return [
        t`How do I add a new audience?`,
        t`How do I choose the best audience for each vendor?`,
        t`How do I create a salesforce audience?`,
      ];
    case 'companySettings':
      return [
        t`What's the best way to set up my TAM?`,
        t`Should I use Custom Opportunity Settings?`,
        t`How do I exclude users that hit certain URLs on my site?`,
      ];
    case 'vendorSpendSettings':
      return [
        t`Can I add spend automatically?`,
        t`How is spend distributed through the month?`,
        t`How do I set up a new vendor to add spend to?`,
      ];
    case 'channelMappingSettings':
      return [t`How do I use channel mapping rules?`, t`Should I customize channel mapping rules?`];
    default:
      return [];
  }
};
